import { splitNavThreadsByPinned } from '@/features/chat/splitNavThreadsByPinned'
import HomeNavPinnedProjectsSection from './HomeNavPinnedProjectsSection'
import HomeNavProjectsSection from './HomeNavProjectsSection'
import styles from './HomeNavRail.module.scss'

/**
 * @param {{
 *   projects?: { id: string, title: string }[],
 *   pinnedProjectIds?: string[],
 *   selectedProjectId?: string | null,
 *   onProjectSelect?: (project: { id: string, title: string }) => void,
 *   onRenameProject?: (project: { id: string, title: string }, title: string) => void,
 * }} props
 */
export default function HomeCodeNavRail({
  projects = [],
  pinnedProjectIds = [],
  selectedProjectId = null,
  onProjectSelect,
  onRenameProject,
}) {
  const { pinnedThreads: pinnedProjects, unpinnedThreads: unpinnedProjects } =
    splitNavThreadsByPinned(projects, pinnedProjectIds)

  return (
    <div className={styles.rail}>
      <HomeNavPinnedProjectsSection
        projects={pinnedProjects}
        selectedProjectId={selectedProjectId}
        onSelectProject={onProjectSelect}
        onRenameProject={onRenameProject}
      />
      <HomeNavProjectsSection
        projects={unpinnedProjects}
        allProjects={projects}
        selectedProjectId={selectedProjectId}
        onSelectProject={onProjectSelect}
        onRenameProject={onRenameProject}
      />
    </div>
  )
}
